import { renderToStaticMarkup } from 'react-dom/server';
import type { TFunction } from 'i18next';
import type { SupplierEvaluationContent } from '@/utils/approval/supplierEvaluation';

/** 상세보기 버튼 — 레거시 문서와 같은 class 라 조회 화면이 같은 자리에서 바꿈 */
export const DETAIL_BUTTON_CLASS = 'apvdetail';

const text = (v: unknown) =>
  v === null || v === undefined ? '' : String(v).trim();

/** 레거시 number_format — 빈 값은 0, 숫자가 아니면 원문 */
const formatNumber = (v: unknown, digits = 0) => {
  const raw = text(v);
  const n = Number(raw.replace(/,/g, '') || 0);
  return Number.isFinite(n)
    ? n.toLocaleString('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })
    : raw;
};

const COL_WIDTHS = [
  '10%',
  '15%',
  '10%',
  '7%',
  '7%',
  '7%',
  '10%',
  '15%',
  '13%',
  '7%',
];

/** 레거시 appr_sub_view_forms_product_result */
const SupplierEvaluationContentView = ({
  content,
  t,
}: {
  content: SupplierEvaluationContent;
  t: TFunction;
}) => {
  const rows = content.rows ?? [];
  return (
    <div>
      <table>
        <colgroup>
          {COL_WIDTHS.map((w, i) => (
            <col key={i} width={w} />
          ))}
        </colgroup>
        <tbody>
          <tr>
            <th className="text-center bg-info" colSpan={8}>
              {t('평가 내역')}
            </th>
            <th className="text-right bg-info" colSpan={2}>
              <button
                type="button"
                className={DETAIL_BUTTON_CLASS}
                data-app-id={text(content.appId)}
                data-detail-url={text(content.detailUrl)}
              >
                {t('상세보기')}
              </button>
            </th>
          </tr>
          <tr>
            <th className="text-center" rowSpan={2}>
              {t('소싱그룹')}
            </th>
            <th className="text-center" rowSpan={2}>
              {t('협력사명')}
            </th>
            <th className="text-center" rowSpan={2}>
              {t('협력사')}
            </th>
            <th className="text-center" colSpan={2}>
              {t('평가점수')}
            </th>
            <th className="text-center" colSpan={4}>
              {t('평가기준')}
            </th>
            <th className="text-center" rowSpan={2}>
              {t('예정 배분 비율')}
            </th>
          </tr>
          <tr>
            {[
              t('전체 점수'),
              t('등수'),
              t('PO 현황'),
              t('기획수량'),
              t('오더금액'),
              t('예상 사입가'),
            ].map((label, i) => (
              <th key={i} className="text-center">
                {label}
              </th>
            ))}
          </tr>
          {rows.map((row, i) => (
            <tr key={i}>
              <td className="text-center">{text(row.evalTypNm)}</td>
              <td className="text-center">{text(row.vdNm)}</td>
              <td className="text-center">{text(row.erpVdCd)}</td>
              <td className="text-right">{formatNumber(row.evalSco, 2)}</td>
              <td className="text-right">{formatNumber(row.sgRank)}</td>
              <td className="text-right">{formatNumber(row.poId)}</td>
              <td className="text-right">{formatNumber(row.itemQty)}</td>
              <td className="text-right">{formatNumber(row.styleTotPrice)}</td>
              <td className="text-right">{formatNumber(row.estBuyPrc)}</td>
              <td className="text-right">{`${text(row.dstrRt)}%`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

/** attributes.content — 조회 화면은 이 HTML 을 그대로 보여 줌 */
export const buildSupplierEvaluationContentHtml = (
  content: SupplierEvaluationContent,
  t: TFunction,
): string =>
  renderToStaticMarkup(
    <SupplierEvaluationContentView content={content} t={t} />,
  );
